import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_minus",
  "use": "icon-icon_minus-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-icon_minus\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h18v18H0z\" /><path fill=\"#93949D\" fill-rule=\"nonzero\" d=\"M3.75 8.25h10.5v1.5H3.75z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol